module.exports = __webpack_public_path__ + "static/media/metrocorp-grey.0461d758.svg";